import React from 'react'
import Container from '../Container/Index'
import Title from '../Title/Index'
import ImageTag from '../ImageTag/Index'
import { wrap } from 'gsap'

const VisionMission = ({ Data }) => {
  const items = Data.values.listitems;

  return (
    <>
      <Container containerClass={'float-end'} _parentClass={'ourCorporate bigTitle'} sectionID={'ethos'}>
        {/* Vision & Mission Section */}
        <div className="col-12 float-start corporate_Bg_Image p-100 blueLayer">
          <div className='row'>
            <Title
              secondHeading={Data.title}
              _spanClass={'text-white'}
              firstHeading={Data.heading}
              _secondHeading={'text-white position-relative'}
            />
            <div className='col-lg-8 col-sm-11 col-11 m-auto'>
              <div className='row justify-content-between position-relative text-white'>
                <div
                  className='col-lg-5 col-sm-6 col-12'
                  data-aos="fade-up"
                  data-aos-offset="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <Title
                    secondHeading={Data.mission.title}
                    _secondHeading={'text-white text-start'}
                    _class={'text-white text-start mb-1'}
                  />
                  <p
                    dangerouslySetInnerHTML={{ __html: Data.mission.content }}
                    data-aos="fade-up"
                    data-aos-offset="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                    data-aos-easing="ease-in-sine"
                  />
                </div>
                <div className='col-lg-5 col-sm-6 col-12'>
                  <Title
                    secondHeading={Data.vision.title}
                    _secondHeading={'text-white text-start'}
                    _class={'text-white text-start mb-2'}
                  />
                  <p dangerouslySetInnerHTML={{ __html: Data.vision.content1 }} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="col-12 float-start Vision py-lg-5 py-2">
          <Title firstHeading={Data.values.title} _class={'mb-4'} _spanClass={'text-white'} />
          <div className='col-lg-11 col-12 m-auto'>
            <div
              className='values-grid'
              data-aos="fade-up"
              data-aos-offset="100"
              data-aos-duration="500"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
            >
              {items.map((item, index) => {
                const firstChar = item.title.charAt(0).toUpperCase();

                return (
                  <div
                    key={index}
                    className='value-item'
                  >
                    {/* Circle with initial */}
                    <div className='value-icon'>
                      <span className='value-char'>
                        {firstChar}
                      </span>
                    </div>
                    <span className='value-title'>{item.title}</span>
                    <p className='value-description'>{item.description}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Container>
    </>
  )
}

export default VisionMission;